<template>
  <div>
    <v-data-table
        dense
        :headers="getAccountPermissionGroupColumn"
        :items="getAccountPermissionGroupList"
        item-key="id"
        class="elevation-1"
        :sort-by="['name']"
        :height="windowHeight"
        :loading="getAccountPermissionGroupListLoading"
        :options="options"
        fixed-header
    >
      <template v-slot:item.last_login="{ item }">
        {{ item.last_login | moment("YY.MM.DD HH:mm") }}
      </template>
      <template v-for="header in getAccountPermissionGroupPermissionColumn" v-slot:[`item.${header.value}`]="{item}">
        <v-checkbox
            class="mt-3 mb-n3"
            v-model="item[header.value]"
            dense
            outlined
        ></v-checkbox>
      </template>

    </v-data-table>
    <v-toolbar flat dense>
      <v-spacer></v-spacer>
      <BaseConformSave class="mr-4" :on-save-external="saveAccountPermissionGroupList" color="primary"
                       :loading="getAccountPermissionGroupListLoading">
      </BaseConformSave>
      <v-btn class="mr-4" :to="{name: 'Home'}">
        Cancel
      </v-btn>
    </v-toolbar>
  </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex';

export default {
  name: 'AccountPermissionGroupList',

  components: {},

  computed: mapGetters(['getAccountPermissionGroupList', 'getAccountPermissionGroupColumn',
    'getAccountPermissionGroupListLoading', 'getAccountPermissionGroupPermissionColumn']),

  methods: {
    ...mapActions(['fetchAccountPermissionGroupList', 'fetchAccountPermissionGroupColumn', 'saveAccountPermissionGroupList']),
    onResize() {
      this.windowHeight = (window.innerHeight - 130) + "px"
      this.windowWidth = (window.innerWidth) + "px"
      console.log('windowHeight')
      console.log(this.windowHeight)
    },
    onSave() {
      this.saveAccountPermissionGroupList();
    }

  },

  async mounted() {
    window.addEventListener("resize", this.onResize)
    await this.fetchAccountPermissionGroupColumn();
    await this.fetchAccountPermissionGroupList();
  },

  created() {
    window.addEventListener("resize", this.onResize);
  },

  destroyed() {
    window.removeEventListener("resize", this.onResize);
  },

  data() {
    return {
      windowHeight: (window.innerHeight - 130) + 'px',
      windowWidth: window.innerWidth + "px",
      options: {
        page: 1,
        itemsPerPage: -1,
        sortBy: ['user_name'],
        sortDesc: [false],
        multiSort: false,
        mustSort: true,
        descending: false,
      },
    }
  }
}
</script>

<style scoped lang="scss">
th {
  background-color: black;
}

//table th + th { border-left:1px solid #dddddd; }
//table td + td { border-left:1px solid #dddddd; }
</style>
